import {createFeatureSelector, createSelector} from "@ngrx/store";
import {AppState} from "../../index";

export const getAppState = createFeatureSelector<AppState>('app');

export const getThemeState = createSelector(
  getAppState,
  (state: AppState) => state.theme
);
